import { TextField } from "@mui/material";
import React, { PropsWithChildren, type JSX } from 'react';
import { Controller, useFormContext } from "react-hook-form";
import { FormFieldPropsBase } from "../form/Form";
import { useMask } from "@react-input/mask";
import { getHoursMinutesSecondsText } from "../../../common/utilities/HoursMinutesSeconds";

export type FormTimeInputProps = {
    rules?: any;
} & FormFieldPropsBase;

export default function FormTimeInput({
    name,
    id,
    testId,
    label,
    ariaLabel,
    //readOnly,
    helperText,
    rules,
    sx,
    disabled,
    size
}: PropsWithChildren<FormTimeInputProps>): JSX.Element {
    const { control } = useFormContext();

    const inputRef = useMask({ 
            mask: "__:__:__", 
            showMask: true,
            replacement: { _: /\d/ },

        });    

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={
                ({
                    field: { ref, name, value, onChange, onBlur },
                    fieldState: { invalid, isTouched, isDirty, error },
                    //formState
                }: {
                    field: any;
                    fieldState: any;
                    formState: any;
                }) => (
                    <TextField
                        variant="filled"
                        id={id}
                        data-testid={testId}
                        aria-label={ariaLabel ?? undefined}
                        label={label ?? undefined}
                        error={invalid}
                        helperText={invalid ? error.message : helperText}
                        onBlur={onBlur}
                        onChange={(ev) => {

                            const newValue = ev.target.value;

                            const parts = newValue.split(':');
                            let total = 0;
                            if (parts.length === 3) {
                                total = +parts[0] * 3600 + +parts[1] * 60 + +parts[2];
                            } else if (parts.length === 2) {
                                total = +parts[0] * 60 + +parts[1];
                            } else {
                                total = +parts[0];
                            }
                
                            value = total as number;
                            onChange(value.toString());
                        }}
                        //inputRef={ref}
                        //value={value}
                        defaultValue={getHoursMinutesSecondsText(value)}
                        sx={{
                            marginTop: 0,
                            ...sx
                        }}
                        disabled={disabled}
                        size={size}
                        slotProps={{
                            input: {
                                inputRef: inputRef,
                            },

                            inputLabel: {
                                shrink: true,
                            }
                        }} />
                )
            }
        />
    );
}